import MainMenu from '@/views/MainMenu.vue'
import type { RouteRecordRaw } from 'vue-router'

const myMapleRoute: RouteRecordRaw = {
  path: '/my-maple',
  name: 'my-maple-index',

  // component: () => import('@/views/my-maple/index.vue'),
  component: MainMenu,
  redirect: { name: 'my-maple' },
  meta: {
    menuTitle: 'My Maple',
    subTitle: 'VIEW YOUR CHARACTERS AND RANKINGS IN ONE PLACE',
    // banners: ['player-ranking', 'maple-guides', 'server-status'],
    // seo: {
    //   description: 'Check out the latest news and read about upcoming content, ongoing events, and more!',
    // },
    gaPageType: 'my maple',
  },
  children: [
    {
      path: ':region?',
      name: 'my-maple',
      component: () => import('@/views/my-maple/index.vue'),
    },
  ],
}

export default myMapleRoute
